import { matchRoutes, RouteObject } from 'react-router-dom';

export const APPLICATION_NAME = 'DevRain Flow';

type PageTitleRoute = RouteObject & { handle: { pageTitle: string } };

// Keep aligned with App routes. Static labels deliberately exclude record/user data.
export const PAGE_TITLE_ROUTES: PageTitleRoute[] = [
  { path: '/', handle: { pageTitle: 'Dashboard' } },
  { path: '/dashboard', handle: { pageTitle: 'Dashboard' } },
  { path: '/customers', handle: { pageTitle: 'Customers' } },
  { path: '/customers/create', handle: { pageTitle: 'Create Customer' } },
  { path: '/customers/edit/:id', handle: { pageTitle: 'Edit Customer' } },
  { path: '/customers/:id', handle: { pageTitle: 'Customer Details' } },
  { path: '/persons', handle: { pageTitle: 'Persons' } },
  { path: '/persons/new', handle: { pageTitle: 'Create Person' } },
  { path: '/persons/edit/:id', handle: { pageTitle: 'Edit Person' } },
  { path: '/persons/:id', handle: { pageTitle: 'Person Details' } },
  { path: '/projects', handle: { pageTitle: 'Projects' } },
  { path: '/projects/create', handle: { pageTitle: 'Create Project' } },
  { path: '/projects/edit/:id', handle: { pageTitle: 'Edit Project' } },
  { path: '/projects/:id', handle: { pageTitle: 'Project Details' } },
  { path: '/leads', handle: { pageTitle: 'Leads' } },
  { path: '/transactions', handle: { pageTitle: 'Transactions' } },
  { path: '/transactions/create', handle: { pageTitle: 'Create Transaction' } },
  { path: '/statistics', handle: { pageTitle: 'Statistics' } },
  { path: '/profitloss', handle: { pageTitle: 'P&L' } },
  { path: '/projectcategories', handle: { pageTitle: 'Categories' } },
  { path: '/tags', handle: { pageTitle: 'Customer Tags' } },
  { path: '/projecttags', handle: { pageTitle: 'Project Tags' } },
  { path: '/activities', handle: { pageTitle: 'Activities' } },
  { path: '/activities/:referenceType/:referenceId/create', handle: { pageTitle: 'Create Activity' } },
  { path: '/activities/:referenceType/:referenceId/edit/:activityId', handle: { pageTitle: 'Edit Activity' } },
  { path: '/activity-log', handle: { pageTitle: 'Activity Log' } },
];

export const resolvePageLabel = (pathname: string): string | undefined => {
  const matches = matchRoutes(PAGE_TITLE_ROUTES, pathname);
  return matches?.[matches.length - 1].route.handle.pageTitle;
};

export const resolveDocumentTitle = (
  pathname: string,
  auth: { isLoading: boolean; isAuthenticated: boolean }
): string => {
  // Auth screens replace protected pages without necessarily changing the URL.
  if (auth.isLoading) return APPLICATION_NAME;
  if (!auth.isAuthenticated) return `Sign in - ${APPLICATION_NAME}`;

  const label = resolvePageLabel(pathname);
  return label ? `${label} - ${APPLICATION_NAME}` : APPLICATION_NAME;
};
